import Layout from "@/components/feature/Layout";
import Seo from "@/components/base/Seo";
import { faqs } from "@/mocks/site";
import Hero from "./components/Hero";
import HotRanking from "./components/HotRanking";
import Categories from "./components/Categories";
import VideoFeed from "./components/VideoFeed";
import Influencers from "./components/Influencers";
import About from "./components/About";
import Faq from "./components/Faq";
import ContactCta from "./components/ContactCta";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      name: "吃瓜视频网 - 娱乐八卦与圈内速递",
      url: "https://soulhandmade.cn/",
      description:
        "吃瓜视频网聚焦娱乐八卦与圈内速递，汇集明星动态、综艺片段、影视花絮及红人视频。",
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [{ "@type": "ListItem", position: 1, name: "首页" }],
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <Layout>
      <Seo
        title="吃瓜视频网 - 娱乐八卦与圈内速递，明星动态综艺影视花絮一网打尽"
        description="吃瓜视频网聚焦娱乐八卦与圈内速递，汇集明星动态、综艺片段、影视花絮及红人视频，实时更新圈内动态，让你轻松掌握娱乐圈新鲜事，追星吃瓜一站搞定。"
        keywords="吃瓜视频网,娱乐八卦,圈内速递,明星动态,综艺片段,影视花絮,红人视频"
        canonical="https://soulhandmade.cn/"
        jsonLd={jsonLd}
      />
      <Hero />
      <HotRanking />
      <Categories />
      <VideoFeed />
      <Influencers />
      <About />
      <Faq />
      <ContactCta />
    </Layout>
  );
}